import React, { useState, useEffect } from 'react';
import {Link, useLocation, useNavigate } from 'react-router-dom';
import styles from './landing-page.module.css'; // Import the CSS file

const LandingPageHome = () => {
    const location = useLocation();
    const [emailOrPhone, setEmailOrPhone] = useState(location.state?.emailOrPhone || '');
    const [tokenPresent, setTokenPresent] = useState(false)
    const token = localStorage.getItem('token');
    const navigate = useNavigate();

    useEffect(() => {
            if (token) {
                setTokenPresent(true)
                navigate('/home');
            }
        }
    ,[]);

    return (
        <div className={styles.landingContainer}>
            <div className={styles.slideshowBackground}></div>
            <div className={styles.landingContent}>
                <h1>Welcome to Unpaid Internships</h1>
                <div className={styles.buttonGroup}>
                    <Link to="/signup">
                        <button className={`${styles.landingButton} ${styles.applicant}`}>SignUp For Free!</button>
                    </Link>
                    <Link to="/login">
                        <button className={`${styles.landingButton} ${styles.recruiter}`}>Login Now!</button>
                    </Link>
                </div>
                {emailOrPhone && <p className={styles.successMessage}>Profile deleted successfully!</p>}
                {tokenPresent?
                    (<Link to="/home">
                        <button className={`${styles.ApplyJobsButton} ${styles.jobs}`}>Browse Jobs-----)</button>
                    </Link>):
                    (<Link to="/guest/home">
                        <button className={`${styles.ApplyJobsButton} ${styles.jobs}`}>Browse Jobs-----)</button>
                    </Link>)
                }

            </div>
        </div>
    );
};

export default LandingPageHome;
